export default {
  'reports.manageReports.components.isAutoManaged': '¿Público?',
  'reports.manageReports.components.isPublic': '¿Es Autogestionado?',
  'reports.manageReports.components.isReportDataFilterByUserCompanyEnabled':
    '¿Filtro de Datos por Usuarios de la Empresa?',
  'reports.manageReports.components.isReportDataFilterByUserEnvironmentEnabled':
    '¿Filtro de Datos por Entorno del Usuario?',
};
